export default __webpack_public_path__ + "static/inclusive-b2f7b377f8ec2f9a6edec7225b9a05c6.svg";